"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Avatar = function (_a) {
    var image = _a.image, size = _a.size;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: 'sr-only' }, "Open user menu"),
        !image && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'user-circle', className: 'storybook-menus-dashboard-avatar' }),
        image && react_1.default.createElement("img", { src: image, className: "storybook-menus-dashboard-avatar-image storybook-menus-dashboard-avatar-image-" + size, alt: '' }));
};
exports.Avatar = Avatar;
exports.Avatar.propTypes = {
    /**
     * The image of the Avatar
     */
    image: prop_types_1.default.string,
    size: prop_types_1.default.string,
};
exports.Avatar.defaultProps = {
    size: 'md'
};
